/* eslint-disable max-lines */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { FC, useCallback, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@material-ui/core';
import lodash from 'lodash';
import moment from 'moment';
import { Modal, notification } from '@gamesb42/ui-kit';

import Title from 'components/common/Title';
import { UseStylingButton, UseStylingDropZoneButton } from 'hooks/useStylingForMaterialUi';
import useCompany, { useCompanyType } from 'hooks/api/useCompany';
import useActivationOrder, { AoTypeEnum, useActivationOrderType } from 'hooks/api/useActivationOrder';
import { getToken } from 'helpers/token';
import { convertFileToBase64 } from 'helpers/file';
import { formatDateIsoShort, getActivationOrderTitle } from 'helpers/formatters';
import useContract, { useContractType } from 'hooks/api/useContract';
import { bodyFutureReceivables, bodyFutureReceivablesNew } from 'queries/activationOrder/createFutureReceivables';
import { bodyAvailableReceivables } from 'queries/activationOrder/createAvailableReceivables';
import urls from 'constants/urls';
import endpoints from 'consts/endpoints';
import useAlert from 'hooks/api/useAlert';
import useErrorCallback from 'hooks/useErrorCallback';
import baseRequest from 'queries/baseRequest';
import { fieldTranslate, fileAODataType, listIsOpenData } from 'components/forms/ActivationOrderForm/data';
import ModalConfirm from 'components/ModalConfirm';
import { getFactorCompany } from 'api/company';
import { CompanyKeyEnum } from 'types/CompanyTypes';

import {
  getFilledPaymentSchedules,
  getPaymentScheduleErrors,
  initialDistributionPlatform,
  initialDistributionPlatformCreateFA,
  initialOrderCardsData,
  isRestrictedEditAo,
  KeyCardsEnum,
  MAP_TYPE_AO_TO_TYPE_FILE,
  StatusEnumAo,
  statusParamsEnum,
  switchListInitial,
} from './CardsAo/data';
import { CLASSIC_RESTRICTED_EDITABLE_KEYS, CLASSIC_SETTINGS_EMPTY_VALUES } from './CardsAo/CardClassic/data';
import getSaveErrorMessage from './getSaveErrorMessage';
import CardClassic from './CardsAo/CardClassic/CardClassic';
import CardApplaud from './CardsAo/CardApplaud/CardApplaud';
import CardAvailableReceivables from './CardsAo/CardAvailableReceivables/CardAvailableReceivables';
import CardNow from './CardsAo/CardNow/CardNow';
import CardFutureReceivables from './CardsAo/CardFutureReceivables/CardFutureReceivables';
import CardFuture from './CardsAo/CardFutureReceivables/CardFuture';
import useErrors from './CardsAo/useErrors';
import useCurrentRequiredKeyOfCard from './CardsAo/useCurrentRequiredKeyOfCard';
import ItemsAo from './CardsAo/ItemsAo';
import CreateTransactionPopUp from './PopUps/CreateTransactionPopUp/CreateTransactionPopUp';

export interface paramsObjAO {
  status?: statusParamsEnum;
  type?: AoTypeEnum;
  companyId?: string;
  activationOrderId?: string;
}

interface ActivationOrderFormType {
  requestParams?: {
    params?: paramsObjAO;
    requestParams?: object;
  };
}

const ActivationOrderForm: FC<ActivationOrderFormType> = React.memo(({ requestParams: { params } }) => {
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);
  const [factorAccounts, setFactorAccounts] = useState([]);
  const { status, type, activationOrderId } = params;
  const paramsUrl = useParams();

  const { t } = useTranslation();
  const { getCompanies, aoFormData, setAOFormData, listSwitch, setIsSwitchList, companiesData }: useCompanyType =
    useCompany();
  const { clearContractsData, getContracts }: useContractType = useContract();

  const stylingButton = UseStylingButton();
  const dropZoneStylingButton = UseStylingDropZoneButton();
  const {
    getActivationOrder,
    activationOrderData,
    clearActivationOrder,
    createActivationOrder,
    createActivationOrderApplaud,
    editActivationOrderApplaud,
    editActivationOrder,
    createAvailableReceivables,
    createFutureReceivables,
    editAvailableReceivables,
    editFutureReceivables,
    getAvailableReceivables,
    getFutureReceivables,
    createScheduleForFutureReceivables,
    editScheduleForFutureReceivables,
    schedulesFutureReceivablesData,
    getScheduleForFutureReceivables,
  }: useActivationOrderType = useActivationOrder();
  const { errors, setErrors, changeErrors, getErrors, addErrors } = useErrors();
  const [listIsOpen, setListIsOpen] = useState(listIsOpenData);
  const { listRequired, errorsList } = useCurrentRequiredKeyOfCard({
    isOpenClosingDatePopUp: !!aoFormData[KeyCardsEnum.TX_DATE],
  });
  const { setAlert } = useAlert();
  const history = useHistory();
  const [isPending, setIsPending] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const successCallback = useCallback(
    (actionType) => {
      setIsPending(false);

      if (actionType.name === 'Cancel' && status === statusParamsEnum.CREATE) {
        history.push(urls.getActivationOrder());

        return;
      }
      history.push(
        `${urls.getActivationOrder()}/${actionType?.id || activationOrderId || ''}/?type=${
          aoFormData?.ao_type || type
        }`,
      );
      // GB42-3427: success feedback as a dark ui-kit notification with a green check
      // icon (bottom-left), replacing the old icon-less Material alert banner.
      let message: string;

      // ответ PUT тоже содержит name, но у него есть id
      if (status === statusParamsEnum.EDIT && actionType?.name && !actionType?.id) {
        message = `${t('alert.activationOrder')} ${actionType.name}`;
      } else if (status !== statusParamsEnum.EDIT) {
        message = t('forms.activationOrder.aoCreatedSuccessfully');
      } else if (actionType?.deleted) {
        message = t('forms.activationOrder.aoDeletedSuccessfully');
      } else {
        message = t('forms.activationOrder.aoChangedSuccessfully');
      }

      notification.success({
        theme: 'dark',
        placement: 'bottomLeft',
        message,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history, setAlert, t, type, aoFormData],
  );

  const { errorCallback } = useErrorCallback(({ errorField, errorCallbackText, customParams }) => {
    setIsPending(false);

    if (errorField === KeyCardsEnum.TX_DATE) {
      setAOFormData({ ...customParams.aoFormData, [KeyCardsEnum.TX_DATE]: errorCallbackText });
      setListIsOpen({ ...listIsOpen, [KeyCardsEnum.TX_DATE]: true });

      return false;
    }

    if (Object.keys(errors).includes(fieldTranslate(errorField))) {
      setErrors('', fieldTranslate(errorField), { required: true });

      return false;
    }

    return true;
  });

  const setFileAO = async (body: fileAODataType) => {
    try {
      const res = await fetch(endpoints.getCreateActivationOrderDocumentUrl(), {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        body: JSON.stringify(body),
      });
      const statusCode = await res;

      if (!statusCode.ok) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (await res.json()) as Promise<any>;
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return (await res.json()) as Promise<any>;
    } catch (iserror) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return iserror as any;
    }
  };

  const currentFactorAccount =
    factorAccounts.find((bankAccount) => bankAccount.currency === activationOrderData.currency) || {};

  const isRestrictedClassicAo =
    status === statusParamsEnum.EDIT &&
    aoFormData.ao_type === AoTypeEnum.CLASSIC &&
    isRestrictedEditAo(AoTypeEnum.CLASSIC, activationOrderData?.status);

  const isActiveOrFundedAo = [StatusEnumAo.ACTIVE, StatusEnumAo.FUNDED].includes(
    String(activationOrderData?.status).toUpperCase(),
  );

  const withClearedClassicSettings = useCallback(
    (obj) => {
      const next = { ...obj };
      const hasSavedValue = (key) =>
        Array.isArray(activationOrderData?.[key])
          ? activationOrderData[key].length > 0
          : Boolean(activationOrderData?.[key]);

      Object.keys(CLASSIC_SETTINGS_EMPTY_VALUES).forEach((key) => {
        if (listSwitch[key] || !hasSavedValue(key)) return;

        next[key] = CLASSIC_SETTINGS_EMPTY_VALUES[key];
      });

      if (!listSwitch[KeyCardsEnum.PAYMENT_DAYS] && activationOrderData?.[KeyCardsEnum.IS_CUSTOM_PAYMENT_DAY]) {
        next[KeyCardsEnum.IS_CUSTOM_PAYMENT_DAY] = false;
      }

      return next;
    },
    [activationOrderData, listSwitch],
  );

  const buildRestrictedClassicPayload = useCallback(
    (obj) => {
      const filtered = {};

      Object.keys(obj).forEach((key) => {
        if (!CLASSIC_RESTRICTED_EDITABLE_KEYS.includes(key)) return;

        const nextValue = obj[key];
        const prevValue = activationOrderData?.[key];
        const isChanged =
          Array.isArray(nextValue) || Array.isArray(prevValue)
            ? !lodash.isEqual(nextValue ?? [], prevValue ?? [])
            : !lodash.isEqual(nextValue ?? null, prevValue ?? null);

        if (isChanged) {
          filtered[key] = nextValue;
        }
      });

      return filtered;
    },
    [activationOrderData],
  );

  const handleClassicSaveError = useCallback(
    (error) => {
      setIsPending(false);
      notification.error({
        theme: 'dark',
        message: getSaveErrorMessage(error, t),
        placement: 'bottomLeft',
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [t],
  );

  // AC-08: navigating to the same AO url is a no-op for react-router, so the card would
  // otherwise keep showing stale pre-save data. Force a fresh GET after a successful save.
  const handleClassicSaveSuccess = useCallback(
    (actionType) => {
      const savedId = actionType?.id || activationOrderId;

      if (savedId) {
        getActivationOrder({ id: savedId });
      }

      successCallback(actionType);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activationOrderId, getActivationOrder, successCallback],
  );

  const onSubmit = useCallback(
    async (isModal?: boolean, isPopUp?: boolean) => {
      // GB42-3427 AC-23: guard against double-submit — a second click while the previous
      // save request is still in flight must not fire a second request.
      if (isPending) return;

      changeErrors({});
      const settingKeys = Object.keys(listSwitch).filter(
        (item) => item !== KeyCardsEnum.CUSTOM_SETTINGS && listSwitch[item],
      );
      const commonCheckKeys = [...settingKeys, ...listRequired];

      Object.keys(errorsList).forEach((objKey) => {
        if (objKey === KeyCardsEnum.ROOT) {
          errorsList[objKey].forEach(({ key, parameters }) => {
            if (commonCheckKeys.find((item) => key === item)) {
              setErrors(aoFormData[key], key, parameters);
            }
          });
        }

        if (
          objKey !== KeyCardsEnum.ROOT &&
          Array.isArray(aoFormData[objKey]) &&
          commonCheckKeys.find((item) => objKey === item)
        ) {
          errorsList[objKey].forEach(({ key, parameters }) => {
            aoFormData[objKey].forEach((itemLocal, i) => {
              Object.keys(itemLocal).forEach((keyLocal) => {
                if (keyLocal === key) {
                  setErrors(aoFormData[objKey][i][key], `${keyLocal}_${i}`, parameters);
                }
              });
            });
          });
        }
      });
      const errorsLocal = getErrors();

      // TODO revert
      // if (!lodash.isEmpty(errorsLocal)) return;

      if (!isModal && status === statusParamsEnum.EDIT) {
        setIsShowModal(true);

        return;
      }
      let obj = {};

      if (isPopUp) {
        obj = { ...obj, sender: currentFactorAccount };
      }

      if (!aoFormData.checkbox && isPopUp) {
        obj = { ...obj, recipient: { company_id: aoFormData.recipient } };
      }

      if (aoFormData.mfa_usd?.toString()?.length > 0) {
        obj = { ...obj, mfa_usd: aoFormData.mfa_usd };
      }

      if (aoFormData.mfa_eur?.toString()?.length > 0) {
        obj = { ...obj, mfa_eur: aoFormData.mfa_eur };
      }

      commonCheckKeys.forEach((key) => {
        if (aoFormData[key]) {
          obj = { ...obj, [key]: aoFormData[key] };
        }
      });

      if (aoFormData[KeyCardsEnum.DROPZONE].length > 0 && MAP_TYPE_AO_TO_TYPE_FILE[aoFormData.ao_type]) {
        const isNewFile = aoFormData[KeyCardsEnum.DROPZONE][0].size;

        if (isNewFile) {
          const fileUrl: string = (await convertFileToBase64(
            aoFormData[KeyCardsEnum.DROPZONE][0],
          )) as unknown as string;
          const result = await setFileAO({
            company_id: aoFormData[KeyCardsEnum.COMPANY_ID] || '',
            file_data: fileUrl,
            name: aoFormData[KeyCardsEnum.NAME],
            number: aoFormData[KeyCardsEnum.NAME],
            type: MAP_TYPE_AO_TO_TYPE_FILE[aoFormData.ao_type],
            date: formatDateIsoShort(new Date()),
          });

          obj = { ...obj, ao_document_id: result.activation_order_document.id };
        }

        if (!isNewFile) {
          obj = { ...obj, ao_document_id: activationOrderData.ao_document_id };
        }
      }

      if (aoFormData.ao_type === AoTypeEnum.CLASSIC) {
        // AC-11: block the save while there are validation errors on the form (e.g. an
        // invalid/out-of-range Repayment Date) instead of silently sending bad data.
        if (!lodash.isEmpty(errorsLocal)) {
          setAlert({ type: 'error', message: t('forms.activationOrder.saveValidationError') });

          return;
        }

        if (aoFormData.purpose) obj = { ...obj, purpose: aoFormData.purpose };
        if (aoFormData.ao_date) obj = { ...obj, ao_date: aoFormData.ao_date };
        if (aoFormData.period) obj = { ...obj, period: aoFormData.period };
        if (aoFormData.reverse_amount) obj = { ...obj, reverse_amount: aoFormData.reverse_amount };
        if (aoFormData.transaction_security) obj = { ...obj, transaction_security: aoFormData.transaction_security };

        if (status === statusParamsEnum.CREATE) {
          setIsPending(true);
          createActivationOrder({
            body: obj,
            successCallback: handleClassicSaveSuccess,
            errorCallback: handleClassicSaveError,
          });
        }

        if (status === statusParamsEnum.EDIT) {
          obj = withClearedClassicSettings(obj);

          // GB42-3473: the PUT contract requires the full set of mandatory fields
          // (amount, company_id, contract_id, currency, interest, name, purchase_date,
          // repayment_date, ...). Sending only the changed subset for an ACTIVE Classic AO
          // makes the API respond 400. Always send the complete payload (unchanged required
          // fields come from the loaded AO) and use the diff only to detect a no-op save.
          if (isRestrictedClassicAo && lodash.isEmpty(buildRestrictedClassicPayload(obj))) {
            setAlert({ type: 'info', message: t('forms.activationOrder.nothingToSave') });

            return;
          }

          setIsPending(true);
          editActivationOrder({
            body: obj,
            id: activationOrderId,
            successCallback: handleClassicSaveSuccess,
            errorCallback: handleClassicSaveError,
          });
        }
      }

      if (aoFormData.ao_type === AoTypeEnum.APPLAUD_FIX) {
        status === statusParamsEnum.CREATE &&
          createActivationOrderApplaud({ body: obj, successCallback, errorCallback });
        status === statusParamsEnum.EDIT &&
          editActivationOrderApplaud({ body: obj, id: activationOrderId, successCallback, errorCallback });
      }

      if (aoFormData.ao_type === AoTypeEnum.AVAILABLE_RECEIVABLES) {
        const resultJSON = await baseRequest({
          path: `${process.env.REACT_APP_BASE_URL_V2}/contracts/${
            status === 'edit' ? aoFormData?.company_id : paramsUrl?.activationOrderId
          }`,
          options: {
            method: 'GET',
          },
        });
        const contractId = resultJSON?.contracts[0]?.id;

        if (!contractId) {
          setAlert({
            type: 'error',
            message: `Document Id not found.`,
          });
          return;
        }

        if (status === statusParamsEnum.CREATE) {
          const resultJSON2 = await baseRequest({
            path: `${process.env.REACT_APP_BASE_URL}/next_ao_number?company_id=${
              status === 'edit' ? aoFormData?.company_id : paramsUrl?.activationOrderId
            }&document_id=${contractId}`,
            options: {
              method: 'GET',
            },
          });
          const nextAoNumber = resultJSON2?.next_ao_number;

          if (!nextAoNumber) {
            setAlert({
              type: 'error',
              message: `Can't get next AO number.`,
            });
            return;
          }

          obj.name = nextAoNumber;
        }

        obj.contract_id = contractId;

        if (!obj.company_id) {
          obj['company_id'] = status === 'edit' ? aoFormData?.company_id : paramsUrl?.activationOrderId;
        }

        if (aoFormData.ao_date) {
          obj['ao_date'] = aoFormData.ao_date;
        }

        status === statusParamsEnum.CREATE &&
          createAvailableReceivables({
            body: obj as bodyAvailableReceivables,
            successCallback,
            errorCallback: (err) => {
              setAlert({
                type: 'error',
                message: JSON.stringify(err?.body?.description),
              });
            },
          });

        status === statusParamsEnum.EDIT &&
          editAvailableReceivables({
            body: obj as bodyAvailableReceivables,
            id: paramsUrl?.activationOrderId,
            successCallback,
            errorCallback,
          });
      }

      if (aoFormData.ao_type === AoTypeEnum.FUTURE_RECEIVABLES || aoFormData.ao_type === AoTypeEnum.FUTURE) {
        // GB42-3499: Payment Day необязателен, поэтому сверяем суммы только если
        // пользователь заполнил хотя бы одну строку графика — иначе пустой блок
        // ложно считается невалидным и блокирует сохранение формы.
        const filledPaymentSchedules = getFilledPaymentSchedules(aoFormData?.schedules);

        if (aoFormData.ao_type === AoTypeEnum.FUTURE && status === statusParamsEnum.CREATE) {
          const scheduleErrors = getPaymentScheduleErrors(aoFormData?.schedules);

          if (!lodash.isEmpty(scheduleErrors)) {
            addErrors(scheduleErrors);

            return;
          }

          if (!lodash.isEmpty(errorsLocal)) return;
        }

        if (
          filledPaymentSchedules.length > 0 &&
          Number(aoFormData?.purchased_receivables) !==
            filledPaymentSchedules.reduce((prev, { amount }) => Number(amount || 0) + prev, 0)
        ) {
          addErrors({
            [KeyCardsEnum.PURCHASED_RECEIVABLES]: 'Total Amount is not equal Purchased Receivables',
            [KeyCardsEnum.PAYMENT_PLAN]: 'Total Amount is not equal Purchased Receivables',
          });

          return;
        }

        const filterEmptyPeriods = aoFormData?.di_period_disabled.filter(
          (el) => el.date_end !== '' && el.date_start !== '',
        );

        const convertDates = (arr) =>
          arr.map((el) => ({
            date_start: moment(el.date_start).format('YYYY-MM-DD'),
            date_end: moment(el.date_end).format('YYYY-MM-DD'),
          }));

        const body = {
          ao_date: aoFormData?.ao_date,
          number: aoFormData?.ao_number,
          purchase_price: aoFormData?.amount,
          purchased_receivables: aoFormData.purchased_receivables,
          currency: aoFormData.currency,
          period: aoFormData.period,
          purchase_date: aoFormData.purchase_date,
          first_repayment_date: aoFormData.first_repayment_date,
          final_repayment_date: aoFormData.final_repayment_date,
          distribution_platforms: aoFormData?.distribution_platforms_fa_create,
          payment_schedules: filledPaymentSchedules,
          company_id: status === statusParamsEnum.EDIT ? aoFormData?.company_id : paramsUrl?.activationOrderId,
          di_period_disabled: filterEmptyPeriods.length > 0 ? convertDates(filterEmptyPeriods) : null,
        };

        status === statusParamsEnum.CREATE &&
          createFutureReceivables({
            body: body as bodyFutureReceivablesNew,
            successCallback: async (activationType) => {
              successCallback(activationType);
            },
            errorCallback: (res) => {
              notification.error({
                theme: 'dark',
                message: res?.text,
                placement: 'bottomLeft',
              });
            },
          });

        if (status === statusParamsEnum.EDIT) {
          setIsSubmittingForm(true);

          editFutureReceivables({
            body: body as bodyFutureReceivablesNew,
            id: activationOrderId,
            successCallback: (activationType) => {
              setIsSubmittingForm(false);
              successCallback(activationType);
            },
            errorCallback: (res) => {
              notification.error({
                theme: 'dark',
                message: res?.text,
                placement: 'bottomLeft',
              });
              setIsSubmittingForm(false);
              errorCallback({ ...res, customParams: { aoFormData } });
            },
          });
        }
      }
    },
    [
      aoFormData,
      listSwitch,
      status,
      listRequired,
      errorsList,
      getErrors,
      isRestrictedClassicAo,
      buildRestrictedClassicPayload,
      withClearedClassicSettings,
      handleClassicSaveError,
      handleClassicSaveSuccess,
      isPending,
    ],
  );

  useEffect(() => {
    if (!lodash.isEmpty(activationOrderData) && status === statusParamsEnum.EDIT) {
      let result = {} as typeof initialOrderCardsData;
      Object.keys(initialOrderCardsData).forEach((key) => {
        if (activationOrderData[key]) {
          // ItemsAo мутирует строки настроек, а стор — эталон для диффа
          result = { ...result, [key]: lodash.cloneDeep(activationOrderData[key]) };
        }
      });

      if (schedulesFutureReceivablesData.records?.length > 0) {
        const cloneOldSchedule = schedulesFutureReceivablesData?.records.map((item) => ({
          ...item,
        }));
        result = {
          ...result,
          [KeyCardsEnum.PAYMENT_PLAN]: cloneOldSchedule,
        };
      }

      if (activationOrderData?.ao_document) {
        result = { ...result, [KeyCardsEnum.DROPZONE]: [new File([], activationOrderData.ao_document.file_name)] };
      }

      if (result?.company_id) {
        getContracts({ id: result.company_id });
      }
      let switchObj = {} as typeof listSwitch;
      Object.keys(listSwitch).forEach((key) => {
        if (Array.isArray(result[key]) && result[key].length > 0) {
          switchObj = { ...switchObj, [key]: true };

          return;
        }

        if (result[key] && !Array.isArray(result[key])) {
          switchObj = { ...switchObj, [key]: true };
        }
      });

      if (!lodash.isEmpty(switchObj)) {
        switchObj.custom_settings = true;
      }

      if (activationOrderData?.payment_schedules?.length > 0) {
        aoFormData.schedules = activationOrderData.payment_schedules;
      }

      if (activationOrderData?.di_period_disabled?.length > 0) {
        aoFormData.di_period_disabled = activationOrderData.di_period_disabled;
      }

      if (activationOrderData?.distribution_platforms?.length > 0) {
        aoFormData.distribution_platforms_fa_create = activationOrderData.distribution_platforms;
      }

      if (activationOrderData?.number?.length > 0) {
        aoFormData.ao_number = activationOrderData.number;
      }

      setIsSwitchList({ ...listSwitch, ...switchObj });
      setAOFormData({ ...aoFormData, ...result });
    }
  }, [activationOrderData, initialOrderCardsData, schedulesFutureReceivablesData]);

  useEffect(() => {
    if (status === statusParamsEnum.EDIT && activationOrderId) {
      (type === AoTypeEnum.CLASSIC || type === AoTypeEnum.APPLAUD_FIX) && getActivationOrder({ id: activationOrderId });
      type === AoTypeEnum.AVAILABLE_RECEIVABLES && getAvailableReceivables({ id: activationOrderId });
      type === AoTypeEnum.FUTURE_RECEIVABLES &&
        getFutureReceivables({
          id: activationOrderId,
          successCallback: async () => {
            await getScheduleForFutureReceivables({ id: activationOrderId });
          },
        });
      type === AoTypeEnum.FUTURE && getActivationOrder({ id: activationOrderId });
    }

    if (type) {
      setAOFormData({ ...aoFormData, [KeyCardsEnum.AO_TYPE]: type });
    }
    getCompanies({ showDeleted: false });

    getFactorCompany()
      .then((result) => {
        const newResult =
          result[CompanyKeyEnum.BANK_DETAILS]
            ?.filter((bankAccount: BankAccount) => bankAccount.master)
            .map((bankAccount: BankAccount) => ({
              [CompanyKeyEnum.BANK_NAME]: bankAccount[CompanyKeyEnum.BANK_NAME] as string,
              [CompanyKeyEnum.SWIFT]: bankAccount[CompanyKeyEnum.SWIFT] as string,
              [CompanyKeyEnum.CURRENCY]: bankAccount[CompanyKeyEnum.CURRENCY] as string,
              [CompanyKeyEnum.ID]: result[CompanyKeyEnum.ID] as string,
              [CompanyKeyEnum.NAME]: result[CompanyKeyEnum.NAME] as string,
            })) || [];

        setFactorAccounts(newResult);
      })
      .catch(console.error);

    return () => {
      clearActivationOrder();
      clearContractsData();
      changeErrors({});
      setIsSwitchList(switchListInitial);
      setAOFormData({
        ...initialOrderCardsData,
        [KeyCardsEnum.DISTRIBUTION_PLATFORMS]: [initialDistributionPlatform],
        [KeyCardsEnum.DISTRIBUTION_PLATFORMS_FA_CREATE]: [initialDistributionPlatformCreateFA],
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const title = getActivationOrderTitle(activationOrderData);

  const getSaveDisable = () => {
    if (
      aoFormData.ao_type === AoTypeEnum.FUTURE_RECEIVABLES &&
      (!aoFormData[KeyCardsEnum.PAYMENT_PLAN]?.[0]?.amount || !aoFormData[KeyCardsEnum.PAYMENT_PLAN]?.[0]?.payment_date)
    )
      return true;

    if (
      aoFormData.ao_type === AoTypeEnum.AVAILABLE_RECEIVABLES &&
      (aoFormData?.distribution_platforms.some(
        (el) =>
          el.currency?.length === 0 ||
          el.platform_id?.length === 0 ||
          el.purchase_percentage?.length === 0 ||
          el.purchase_price_percentage?.length === 0,
      ) ||
        ((aoFormData?.mfa_usd === null || aoFormData.mfa_usd?.toString()?.length === 0) &&
          (aoFormData?.mfa_eur === null || aoFormData?.mfa_eur?.toString()?.length === 0)))
    ) {
      return true;
    }

    return isPending;
  };

  return (
    <form style={{ maxWidth: 608 }}>
      <CreateTransactionPopUp
        isOpen={listIsOpen[KeyCardsEnum.TX_DATE]}
        onClose={() => setListIsOpen({ ...listIsOpen, [KeyCardsEnum.TX_DATE]: false })}
        style={{ width: 720 }}
        isSubmittingForm={isSubmittingForm}
        leftCallback={() => {
          if (!lodash.isEmpty(errors)) return;

          onSubmit(true, true);
        }}
        rightCallback={() => successCallback({ name: t('forms.activationOrder.aoStatusCantBeChanged') })}
      />
      <Title
        text={status === statusParamsEnum.EDIT ? title : `${t('forms.activationOrder.createActivationOrder')}`}
        aoType={status === statusParamsEnum.EDIT ? aoFormData.ao_type : undefined}
        status={status === statusParamsEnum.EDIT ? activationOrderData?.status : undefined}
      />

      {aoFormData.ao_type === AoTypeEnum.CLASSIC && <CardClassic params={params} />}
      {aoFormData.ao_type === AoTypeEnum.APPLAUD_FIX && <CardApplaud params={params} />}
      {aoFormData.ao_type === AoTypeEnum.AVAILABLE_RECEIVABLES && <CardNow params={params} />}
      {aoFormData.ao_type === AoTypeEnum.FUTURE_RECEIVABLES && <CardFutureReceivables params={params} />}
      {aoFormData.ao_type === AoTypeEnum.FUTURE && <CardFuture params={params} />}

      <div style={{ margin: '40px 0 24px 0' }}>
        <Button
          type="button"
          onClick={() => {
            if (status === statusParamsEnum.EDIT && isActiveOrFundedAo) {
              Modal.info({
                title: t('forms.activationOrder.saveAoChangesTitle'),
                content: (
                  <>
                    <p>{t('forms.activationOrder.saveAoChangesRecalculated')}</p>
                    <p>{t('forms.activationOrder.saveAoChangesDocumentUnchanged')}</p>
                  </>
                ),
                okText: t('global.saveChanges'),
                cancelText: t('global.cancelC'),
                cancelButtonProps: { style: { padding: '10px 20px 8px' } },
                onOk: () => {
                  onSubmit(true);
                },
                onCancel: () => {},
              });
            } else if (status === statusParamsEnum.EDIT) {
              // Modal.info: no attention icon, left-aligned content (design per GB42-3427 mockup).
              Modal.info({
                title: t('forms.activationOrder.regeneratePdfTitle'),
                content: t('forms.activationOrder.regeneratePdfText'),
                okText: t('forms.activationOrder.saveAndRegenerate'),
                cancelText: t('global.cancelC'),
                onOk: () => {
                  onSubmit(true);
                },
                onCancel: () => {},
              });
            } else {
              onSubmit();
            }
          }}
          style={{ height: 40, width: 198, marginRight: 24 }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...stylingButton}
          disabled={getSaveDisable()}
        >
          {status === statusParamsEnum.EDIT ? t('global.saveChanges') : t('global.saveS')}
        </Button>
        <Button
          style={{ height: 40, width: 89 }}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...dropZoneStylingButton}
          onClick={() => successCallback({ name: 'Cancel' })}
        >
          {t('global.cancelC')}
        </Button>
      </div>
    </form>
  );
});

export default ActivationOrderForm;
